function PopupBanner() {
    $(".js-popup-banner").click(function (e) {
        e.preventDefault();
        $.fancybox.open($("#popup-test-drive"), {
            touch: false,
            mobile: {
                touch: true
            }
        });
    })
}

export { PopupBanner };

